import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import BranchService from "../../../services/KangarooServices/BranchService";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const Branch = () => {
  const router = useNavigate();
  const [branchData, setBranchData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10); // you can make this dynamic
  const [totalPages, setTotalPages] = useState(1);

  const fetchData = async () => {
    try {
      const res = await BranchService.getList({
        searchText: searchTerm,
        page: page,
        pageSize: pageSize,
      });

      setBranchData(res.items || []);
      setTotalPages(res.totalPages || 1); // adjust depending on your API response
    } catch (error) {
      console.error("Failed to fetch branch data:", error);
      setBranchData([]);
      setTotalPages(1);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, searchTerm]); // fetch data when page or search changes

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    if (selectedCustomer) {
      try {
        await BranchService.delete(selectedCustomer);
        fetchData(); // refetch current page after delete
        toast.success("Selected item deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };

  document.title = "Branch | Kangaroo Foundation";

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(1); // reset to first page on search
  };

  const handlePrevPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Branch Location" pageTitle="Location & Affiliation" />

        <Row className=" mb-3">
          <Col lg={4}>
            <Button color="success" onClick={() => router("/addbranch")}>
              <i className="ri-add-line align-bottom me-1"></i>
              Add Branch
            </Button>
          </Col>
          <Col lg={8}>
            {/* <div className="d-flex justify-content-sm-end"> */}
              <div className="search-box">
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Search by branch, city or country"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <i className="ri-search-line search-icon"></i>
              </div>
            {/* </div> */}
          </Col>
        </Row>

        <Row className="g-3">
          {branchData.map((item, key) => (
            <Col xxl={3} xl={4} lg={6} md={6} key={key}>
              <Card className="border h-100 p-2">
                <CardBody className="p-2">
                  <div className="d-flex gap-2">
                    <div className="">
                      <img
                        src={`${imageBaseApi}${item?.media?.url}`}
                        alt={item.officeName}
                        className="rounded img-fluid object-fit-contain"
                        width="80"
                        height="80"
                      />
                    </div>
                    <div className="flex-grow-1 overflow-hidden ms-4">
                      <a
                        href={item.googleMapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <h6 className="fs-14 mb-1 text-dark text-truncate">
                          {item.officeName}
                          <i className="ri-external-link-line ms-1 fs-12 text-muted"></i>
                        </h6>
                      </a>
                      <p className="text-muted mb-1 fs-12 text-truncate">
                        <i className="ri-user-line me-1 text-primary"></i>
                        {item.officeHeadName}
                      </p>
                      <span className="badge bg-light text-dark border fs-11">
                        <i className="ri-map-pin-line me-1"></i>
                        {item.city}, {item.country}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 pt-2 border-top">
                    <div className="mb-1">
                      <p className="text-muted mb-0 fs-12 text-truncate">
                        <i className="ri-map-pin-2-fill text-primary me-1"></i>
                        {item.address}
                      </p>
                    </div>
                    <div className="mb-1">
                      <p className="text-muted mb-0 fs-12 text-truncate">
                        <i className="ri-phone-fill text-primary me-1"></i>
                        {item.phone}
                      </p>
                    </div>
                    <div className="mb-1">
                      <p className="text-muted mb-0 fs-12 text-truncate">
                        <i className="ri-mail-fill text-primary me-1"></i>
                        {item.email}
                      </p>
                    </div>
                    <div className="mt-2 pt-2 border-top">
                      <div className="d-flex align-items-center">
                        <div className="avatar-xs bg-success-subtle rounded me-2">
                          <div className="avatar-title bg-transparent text-success fs-12">
                            <i className="ri-time-line"></i>
                          </div>
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                          <p className="text-muted mb-0 fs-11">Opening Hours</p>
                          <p className="fw-semibold mb-0 fs-12 text-truncate">{item.openingHours}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
                <div className="card-footer bg-transparent border-top p-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <Link to={`/branch/${item.id}`} className="link-secondary text-decoration-none fs-13">
                      View Detail <i className="ri-arrow-right-s-line ms-1"></i>
                    </Link>
                    <div className="d-flex gap-1">
                      <Button color="warning" size="sm" className="btn-icon btn-sm" onClick={() => router(`/addbranch/${item.id}`)}>
                        <i className="ri-edit-line"></i>
                      </Button>
                      <Button color="danger" size="sm" className="btn-icon btn-sm" onClick={() => handleDeleteClick(item.id)}>
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        <Row className="g-0 justify-content-end mt-3">
          <Col sm={6}>
            <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end">
              <div className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <Button className="page-link" onClick={handlePrevPage}>
                  Previous
                </Button>
              </div>
              <span className="pagination d-flex justify-content-center align-content-center align-items-center">
                Page {page} of {totalPages}
              </span>
              <div className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <Button className="page-link" onClick={handleNextPage}>
                  Next
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedCustomer}
      />
    </div>
  );
};

export default Branch;
